/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VacationRequestWithRelations } from './vacationRequestWithRelations';
import { UserWithRelations } from './userWithRelations';


/**
 * (tsType: VacationRequestHistoryWithRelations, schemaOptions: { includeRelations: true })
 */
export interface VacationRequestHistoryWithRelations { 
    id?: string;
    vacationRequestId: string;
    previousStatus?: VacationRequestHistoryWithRelations.PreviousStatusEnum;
    newStatus: VacationRequestHistoryWithRelations.NewStatusEnum;
    changedBy: number;
    changedAt?: string;
    comments?: string;
    metadata?: object;
    vacationRequest?: VacationRequestWithRelations;
    changedByUser?: UserWithRelations;
}
export namespace VacationRequestHistoryWithRelations {
    export type PreviousStatusEnum = 'draft' | 'pending' | 'approved_by_boss' | 'pending_payroll' | 'approved_by_payroll' | 'rejected' | 'cancelled' | 'completed';
    export const PreviousStatusEnum = {
        Draft: 'draft' as PreviousStatusEnum,
        Pending: 'pending' as PreviousStatusEnum,
        ApprovedByBoss: 'approved_by_boss' as PreviousStatusEnum,
        PendingPayroll: 'pending_payroll' as PreviousStatusEnum,
        ApprovedByPayroll: 'approved_by_payroll' as PreviousStatusEnum,
        Rejected: 'rejected' as PreviousStatusEnum,
        Cancelled: 'cancelled' as PreviousStatusEnum,
        Completed: 'completed' as PreviousStatusEnum
    };
    export type NewStatusEnum = 'draft' | 'pending' | 'approved_by_boss' | 'pending_payroll' | 'approved_by_payroll' | 'rejected' | 'cancelled' | 'completed';
    export const NewStatusEnum = {
        Draft: 'draft' as NewStatusEnum,
        Pending: 'pending' as NewStatusEnum,
        ApprovedByBoss: 'approved_by_boss' as NewStatusEnum,
        PendingPayroll: 'pending_payroll' as NewStatusEnum,
        ApprovedByPayroll: 'approved_by_payroll' as NewStatusEnum,
        Rejected: 'rejected' as NewStatusEnum,
        Cancelled: 'cancelled' as NewStatusEnum,
        Completed: 'completed' as NewStatusEnum
    };
}


